import React from 'react';
import PropTypes from 'prop-types';
import InsightAgGridTable from './InsightAgGridTable';
import {
    CAMPAIGN_NAME,
    Category,
    OS,
    COUNTRY,
    CREATIVE_TYPE,
    AGG_SUM,
    IMPRESSIONS,
    COST,
    CREATIVE_EFFICIENCY_SCORE,
    AGG_AVG,
} from '../consts';

const TOP_BOTTOM_DIMENSIONS = [CREATIVE_TYPE, OS, CAMPAIGN_NAME, COUNTRY];
const TOP_BOTTOM_METRICS = {
    [COST]: AGG_SUM,
    [IMPRESSIONS]: AGG_SUM,
    [CREATIVE_EFFICIENCY_SCORE]: AGG_AVG,
};

const InsightTable = ({ table, category }) => {
    if (!table || table.length <= 1) {
        return null;
    }

    if (category === Category.TOP_BOTTOM_PERFORMING) {
        return (
            <InsightAgGridTable
                table={table}
                dimensionColumns={TOP_BOTTOM_DIMENSIONS}
                metricAggregations={TOP_BOTTOM_METRICS}
                showRowGroupPanel
            />
        );
    }

    return <InsightAgGridTable table={table} />;
};

InsightTable.propTypes = {
    table: PropTypes.array,
    category: PropTypes.string,
};

export default InsightTable;
